import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-field-error',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldErrorComponent {
  @Input() control: AbstractControl | null = null;
  @Input() label: string | null = null;

  get messages(): string[] {
    const control = this.control;
    if (!control || !control.touched || !control.errors) {
      return [];
    }

    const errors = control.errors;
    const messages: string[] = [];
    const label = this.label?.trim() || 'Este campo';

    if (errors['required']) {
      messages.push(`${label} es obligatorio`);
    }

    if (errors['min']) {
      const min = errors['min']?.min;
      if (min !== undefined && min !== null) {
        messages.push(`${label} debe ser mayor o igual a ${min}`);
      }
    }

    const backendMessage = errors['backend'] || errors['server'];
    if (backendMessage) {
      if (Array.isArray(backendMessage)) {
        backendMessage.forEach((msg) => messages.push(String(msg)));
      } else {
        messages.push(String(backendMessage));
      }
    }

    return messages;
  }
}
